import { useNotificationsStore } from "@/store/notifications.js";
import { useProjectStore } from "@/store/project.js";
import { useUserStore } from "@/store/user.js";

import { ROLES } from "@/utils/users";

// Check if user is authorized to access a page or not, if
// not redirect to home page
// Only needed for external users for now
export const projectUserPermission = async (to, from, next) => {
  const projectStore = useProjectStore();
  if (useUserStore().isDevOrSuperUser) {
    return next();
  }
  try {
    await projectStore.fetchCurrentProjectUser({
      projectId: to.params.projectId,
    });
  } catch (err) {
    console.error("projectUserPermission", err);
    useNotificationsStore().showErrorNotification("projects.project_access_denied");
    return next(from.matched.length ? false : "/");
  }

  const projectUserRole = projectStore.getCurrentProjectUserRole;

  if (to.meta.allowExternalNoAccess) {
    return next();
  }

  if (to.meta.allowExternal && projectUserRole !== ROLES.EXTERNAL_NO_ACCESS) {
    return next();
  }

  if (![ROLES.EXTERNAL_NO_ACCESS, ROLES.EXTERNAL].includes(projectUserRole)) {
    return next();
  }

  return next({ name: "projectUser", params: to.params });
};
